import { useTranslation } from 'Modules/core/i18n';

import { useDocs } from '../../state/documents';
import { DocumentsCommonProps } from '../DocumentsCommon/types';
import { Document } from '../../api';


interface Group extends DocumentsCommonProps {
    checklist: string | undefined;
    testData?: string;
}

interface SplittedDocuments extends Pick<Group, 'checklist'> {
    downloads: Document[];
    templates: Document[];
}

interface UlPartnerDocuments extends Pick<Group, 'checklist'> {
    documents: Document[];
}

const findChecklist = (documents: Document[]): Group['checklist'] =>
    documents.find(el => el.checklist)?.file.url;

const formatDocuments = (documents: Document[] = []): SplittedDocuments => ({
    checklist: findChecklist(documents),
    downloads: documents.filter(el => !!el.file?.url && !el.checklist),
    templates: documents.filter(el => !el.file?.url),
});

const formatUlPartnerDocuments = (documents: Document[] = []): UlPartnerDocuments => ({
    checklist: findChecklist(documents),
    documents: documents.filter(el => !el.checklist),
});


export const useRegistrationsDocuments = (): Group[] => {
    const { t } = useTranslation('documents');

    const {
        data: ipDocuments,
        isLoading: ipDocumentsLoading,
    } = useDocs<SplittedDocuments>('ip', formatDocuments);
    const {
        data: companyDocuments,
        isLoading: companyDocumentsLoading,
    } = useDocs<SplittedDocuments>('company', formatDocuments);
    const {
        data: flPartnerDocuments,
        isLoading: flPartnerDocumentsLoading,
    } = useDocs<UlPartnerDocuments>('flPartner', formatUlPartnerDocuments);

    return [
        {
            title: t('ulRegistration') as string,
            testData: 'juridicalCkeckList',
            checklist: companyDocuments?.checklist,
            showLoader: companyDocumentsLoading,
            documents: [
                {
                    subtitle: t('downloads') as string,
                    files: companyDocuments.downloads,
                },
                {
                    subtitle: t('templates') as string,
                    files: companyDocuments.templates,
                },
            ],
        },
        {
            title: t('ipRegistration') as string,
            testData: 'ipCheckList',
            checklist: ipDocuments?.checklist,
            showLoader: ipDocumentsLoading,
            documents: [
                {
                    subtitle: t('downloads') as string,
                    files: ipDocuments.downloads,
                },
                {
                    subtitle: t('templates') as string,
                    files: ipDocuments.templates,
                },
            ],
        },
        {
            title: t('partnerFlRegistration') as string,
            testData: 'flCkeckList',
            checklist: flPartnerDocuments.checklist,
            showLoader: flPartnerDocumentsLoading,
            documents: [
                {
                    files: flPartnerDocuments.documents,
                },
            ],
        },
    ];
};
